import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Centralized auth handling. 401 (no/invalid/expired session) vs 403 (insufficient
// permission) are treated distinctly. The silent /auth/me probe never redirects.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const isAuthProbe = url.includes("/auth/me");
    if (status === 401) {
      error.isAuthError = true;
      if (!isAuthProbe) {
        const onLogin = window.location.pathname.startsWith("/login");
        if (!onLogin) {
          toast.error("Your session has expired. Please log in again.");
          const next = encodeURIComponent(window.location.pathname + window.location.search);
          window.location.href = `/login?next=${next}`;
        }
      }
    } else if (status === 403) {
      error.isAuthError = true;
      toast.error("You don't have permission to perform this action.");
    }
    return Promise.reject(error);
  }
);

export default api;
